import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import { CatIconClose } from "blocks-nextjs/blocks-react/components/Icons/Close/Close";
import { CatIconWarningTriangleFilled } from "blocks-nextjs/blocks-react/components/Icons/WarningTriangleFilled/WarningTriangleFilled";
import React from "react";
import { useUpdateOrDeactivateChargerLink } from "../../services/query/eflow-charge-operation-planner-api.query";
import useGlobalStore from "../../store/useGlobalStore";
import useProjectDetailsStore from "../../store/useProjectDetailsStore";
import { ChargerAssetLinkUpdateRequest } from "../../swagger/eFlowService-v1/models/ChargerAssetLinkUpdateRequest";
import { Variant } from "../GlobalNotification/GlobalNotification";
const ERROR_MSG_DEACTIVATE_FAILED = "Failed to Deactivate the link";
const ERROR_MSG_MISSING_IDS = "Cannot deactivate: Missing required assetId, projectId, or partyNumber";
const CONFIRM_BUTTON_CLASSES = "bg-[#D03027] text-white hover:bg-[#B02017] flex items-center gap-2 px-4 py-2 rounded font-medium transition-colors";
const CANCEL_BUTTON_CLASSES = "text-blue-600 font-medium hover:text-blue-800";
const buildMutateCallbacks = (setGlobalNotification, onClose, onConfirm) => ({
    onError: () => {
        setGlobalNotification({
            message: `${ERROR_MSG_DEACTIVATE_FAILED}.`,
            showNotification: true,
            type: Variant.error
        });
        onClose();
    },
    onSuccess: () => {
        onConfirm();
    }
});
const DeactivateLinkModal = ({ deactivatingLinkData, isOpen, onClose, onConfirm }) => {
    const { mutate: updateOrDeactivateLinkMutate } = useUpdateOrDeactivateChargerLink();
    const { setGlobalNotification, userPartyNumber } = useGlobalStore((state) => ({
        setGlobalNotification: state.setGlobalNotification,
        userPartyNumber: state.userPartyNumber
    }));
    const { assetDetails, projectMetaData } = useProjectDetailsStore((state) => ({
        assetDetails: state.assetDetails,
        projectMetaData: state.projectMetaData
    }));
    if (!isOpen)
        return null;
    const handleDeactivateLink = () => {
        if (deactivatingLinkData) {
            // Don't proceed if required IDs are missing
            if (!assetDetails?.assetId || !projectMetaData?.projectId || !userPartyNumber) {
                console.error(ERROR_MSG_MISSING_IDS);
                return;
            }
            const chargerAssetLinkUpdateRequest = {
                assetId: assetDetails.assetId,
                expiryDate: deactivatingLinkData.expiryDate,
                features: [
                    ...(deactivatingLinkData.features.liveViewOnly ? ["live view only"] : []),
                    ...(deactivatingLinkData.features.canSeeHistory ? ["can see history"] : []),
                    ...(deactivatingLinkData.features.canUseChargerControls
                        ? ["can use charger controls"]
                        : []),
                    ...(deactivatingLinkData.features.canUseSchedule ? ["can use schedule"] : [])
                ],
                link: deactivatingLinkData.link,
                name: deactivatingLinkData.name,
                partyNumber: userPartyNumber,
                projectId: projectMetaData.projectId,
                status: ChargerAssetLinkUpdateRequest.status.DEACTIVATED
            };
            updateOrDeactivateLinkMutate(chargerAssetLinkUpdateRequest, buildMutateCallbacks(setGlobalNotification, onClose, onConfirm));
        }
    };
    return (_jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50", children: _jsxs("div", { className: "bg-white rounded-lg shadow-xl w-full max-w-lg mx-4 overflow-hidden", children: [_jsxs("div", { className: "flex justify-between items-start p-6 pb-2", children: [_jsx(CatHeading, { variant: "title-sm", children: "Do you want to deactivate the link?" }), _jsx("button", { className: "text-gray-500 hover:text-gray-700", "data-test": "deactivate-link-modal-close-button", onClick: onClose, children: _jsx(CatIconClose, {}) })] }), _jsxs("div", { className: "p-6 pt-2", children: [_jsxs("p", { className: "text-gray-600 mb-8", children: ["Are you sure you want to delete this generated link?", _jsx("br", {}), "This action cannot be undone."] }), _jsxs("div", { className: "flex items-center gap-4", children: [_jsxs("button", { className: CONFIRM_BUTTON_CLASSES, "data-test": "deactivate-link-confirm-button", onClick: handleDeactivateLink, children: [_jsx(CatIconWarningTriangleFilled, { className: "text-white w-5 h-5" }), "Deactivate Link"] }), _jsx("button", { className: CANCEL_BUTTON_CLASSES, "data-test": "deactivate-link-cancel-button", onClick: onClose, children: "Cancel" })] })] })] }) }));
};
export default DeactivateLinkModal;
